import { gql } from "@apollo/client";

export const USER_TYPES = gql`
	query ($operatorId: ID!) {
		lockerUserTypes(operatorId: $operatorId) {
			userTypeId
			userType
			description
			monthlyFee
		}
	}
`;

export const UPDATE_USER_TYPE = gql`
	mutation ($userTypes: [UpdateUserTypeObject]!) {
		updateLockerUserType(userTypes: $userTypes) {
			lockerUserType {
				userTypeId
			}
		}
	}
`;

export const CREATE_USER_TYPE = gql`
	mutation (
		$operatorId: ID!
		$userType: String!
		$description: String!
		$monthlyFee: Decimal!
		$sort: Int!
	) {
		createLockerUserType(
			operatorId: $operatorId
			userType: $userType
			description: $description
			monthlyFee: $monthlyFee
			sort: $sort
		) {
			lockerUserType {
				userTypeId
				userType
				description
				monthlyFee
			}
		}
	}
`;
